import Training from '../training';
/**
 * Create the action
 */

const { thunk, request, success, error } = Training.index((fetch) =>
    fetch.get('training')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
